import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import cn from 'clsx';
import { UIText1, IconChevronDown16 } from '@cian/ui-kit';
import { useAccordionState } from './utils/useAccordionState';
import styles from './styles.css';

/**
 * Компонент аккордеона (отдельный раскрывающийся блок).
 *
 * По-умолчанию является неуправляемым. Переключение на управляемый режим
 * происходит, если проп `open === true || false`.
 *
 * @deprecated Используйте Accordion из ui-kit
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Accordion = function Accordion(_ref) {
  var title = _ref.title,
    children = _ref.children,
    onClick = _ref.onClick,
    open = _ref.open,
    defaultOpen = _ref.defaultOpen,
    icon = _ref.icon;
  var _useAccordionState = useAccordionState({
      open: open,
      defaultOpen: defaultOpen,
      onClick: onClick
    }),
    isOpen = _useAccordionState.isOpen,
    clickHandler = _useAccordionState.clickHandler;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("button", {
      className: cn(styles['header-container'], icon && styles['header-container-with-icon']),
      type: "button",
      "aria-expanded": isOpen,
      onClick: clickHandler,
      children: [icon && /*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: icon
      }), /*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(UIText1, {
          fontWeight: "bold",
          children: title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cn(styles['arrow'], _defineProperty({}, styles['active'], isOpen)),
        "aria-hidden": true,
        children: /*#__PURE__*/_jsx(IconChevronDown16, {})
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles['content'], _defineProperty({}, styles['active'], isOpen)),
      children: children
    })]
  });
};
Accordion.displayName = 'Accordion';